import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatTooltip } from '@blocks-react/components/Tooltip';
import { CatTextPassage } from '@blocks-react/components/TextPassage';
export const EquipmentNameTooltip = ({ toolTipContent, children }) => {
    return (_jsxs(CatTooltip, { position: "auto", children: [children, _jsx(CatTextPassage, { children: toolTipContent })] }));
};
